module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Generator-42987fc85f113a472bfa55fdc662ee52.svg";